import { TechnicalDataComponent } from './technical-data/technical-data.component'
import { Component, inject, signal, AfterViewInit, computed } from '@angular/core'
import { MatStepperModule } from '@angular/material/stepper'
import { MatIconModule } from '@angular/material/icon'

import { NotificationComponent } from './shared/components/notification/notification.component'
import { LoadingSpinnerComponent } from './shared/components/loading-spinner/loading-spinner.component'
import { GeneralFormControls, OfferFormService } from './shared/services/offer-form.service'
import { FormGroup } from '@angular/forms'
import { SuccessMessageComponent } from './overview/success-message/success-message.component'
import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper'
import { IframeResizeService } from './shared/services/iframe-resize.service'
import { IndicativeOfferService } from './shared/services/indicative-offer.service'
import { ContactComponent } from './contact/contact.component'
import { PriceComponent } from './price/price.component'
import { toSignal } from '@angular/core/rxjs-interop'

enum StepperLabel {
  TechData = 'Technische Daten',
  Prices = 'Preisvorschau',
  Contact = 'Kontaktdaten',
}

@Component({
  selector: 'app-root',
  imports: [
    MatStepperModule,
    TechnicalDataComponent,
    ContactComponent,
    NotificationComponent,
    MatIconModule,
    LoadingSpinnerComponent,
    SuccessMessageComponent,
    PriceComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class AppComponent implements AfterViewInit {
  // IframeResizeService should be initialized but might be not used
  private resizeService = inject(IframeResizeService)
  private indicativeOfferService = inject(IndicativeOfferService)
  private readonly offerFormService = inject(OfferFormService)
  generalDataFormGroup: FormGroup<GeneralFormControls> = this.offerFormService.generalData
  protected readonly priceForm = this.offerFormService.priceData
  protected readonly overviewStepCompleted = computed(() => !!this.indicativeOfferService.requestId())

  protected readonly priceFormStatus = toSignal(this.priceForm.statusChanges, {
    initialValue: this.priceForm.status,
  })
  protected readonly generalDataFormStatus = toSignal(this.generalDataFormGroup.statusChanges, {
    initialValue: this.generalDataFormGroup.status,
  })
  private readonly selectedStep = signal<StepperLabel>(StepperLabel.TechData)

  protected readonly isPriceStepVisible = computed(() => this.selectedStep() === StepperLabel.Prices)

  protected readonly priceStepCompleted = computed(() => this.priceFormStatus() === 'VALID')

  protected readonly priceStepHasPointer = computed(
    () => this.generalDataFormStatus() === 'VALID' && this.selectedStep() !== StepperLabel.Prices
  )
  protected readonly contractStepHasPointer = computed(
    () => this.priceStepCompleted() && this.selectedStep() !== StepperLabel.Contact
  )

  ngAfterViewInit(): void {
    this.resizeService.sendHeightMessageOnResize()
  }

  onSelectionChange(event: StepperSelectionEvent): void {
    this.selectedStep.set(event.selectedStep.ariaLabel as StepperLabel)
  }

  protected readonly StepperLabel = StepperLabel
}
